import baseTheme from '../baseTheme';
var MuiFormGroup = {
    /* your custom class style overrides here */
    root: {
        '& > * + *': {
            marginTop: baseTheme.spacing(1),
        },
    },
};
export default MuiFormGroup;
//# sourceMappingURL=MuiFormGroup.js.map